import { Box } from '@mui/material';
import React from 'react';
import FundOpportunity from '../../models/FundOpportunity';
import { IRRUpdate } from '../../models/IRRUpdate';
import { toMoneyMultiple } from '../../pages/fundUpdate/fundUpdateUtils';
import { StyledHeading } from '../styles/styles';
import IRRMetrics from './IRRMetrics';

export interface FundUpdateMetricsRowProps {
  fundOpportunity: FundOpportunity;
  irrUpdates: IRRUpdate[];
  /** Admin's Fund Management preview renders these tiles smaller, to suit the narrower admin content column. */
  canEdit?: boolean;
}

const FundUpdateMetricsRow: React.FC<FundUpdateMetricsRowProps> = ({
  fundOpportunity,
  irrUpdates,
  canEdit = false,
}) => {
  return (
    <>
      {canEdit && (
        <StyledHeading headerVariant="subheading" reduceBottomPadding sx={{ mb: '10px' }}>
          Key Metrics
        </StyledHeading>
      )}
      <Box
        sx={{
          maxWidth: undefined,
          display: 'flex',
          flexDirection: {
            xs: 'column',
            md: 'row',
          },
          justifyContent: {
            xs: 'flex-start',
            md: 'space-between',
          },
          gap: canEdit ? 1.5 : 3,
          mb: canEdit ? 2 : 4,
          flexWrap: canEdit ? 'nowrap' : { md: 'wrap', lg: undefined },
        }}
      >
        <IRRMetrics
          title="IRR"
          field="irr"
          expandedTitle="Internal Rate of Return (IRR)"
          fundOpportunity={fundOpportunity}
          imValue={fundOpportunity.interest!}
          unit="%"
          description="Current Forecast"
          irrUpdates={irrUpdates}
          canEdit={canEdit}
        />
        <IRRMetrics
          title="ROE"
          field="roe"
          expandedTitle="Return on Equity (ROE)"
          fundOpportunity={fundOpportunity}
          imValue={fundOpportunity.returnOnInvestment!}
          unit="%"
          description="Current Forecast"
          irrUpdates={irrUpdates}
          canEdit={canEdit}
        />
        <IRRMetrics
          title="MM"
          field="mm"
          expandedTitle="Money Multiple (MM)"
          fundOpportunity={fundOpportunity}
          imValue={toMoneyMultiple(fundOpportunity.returnOnInvestment)!}
          unit="x"
          description="Current Forecast"
          irrUpdates={irrUpdates}
          canEdit={canEdit}
        />
      </Box>
    </>
  );
};

export default FundUpdateMetricsRow;
